<template>
  <div class="cp__loader__container">
    <img width="80px" height="80px" alt="Processing..." :src="processingGIF" @error="setDefaultLoader($event)" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ProcessingLoader',
  computed: {
    ...mapGetters(['processingGIF'])
  },
  methods: {
    setDefaultLoader: function(event) {
      event.error = null
      event.target.src = '@/assets/images/loader.svg'
    }
  }
}
</script>

<style scoped>

</style>
